(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('searchBox', searchBox);

    var tmplt = "<div class='form-group input-group'>\
                            <input type='text' class='form-control'\
                                 ng-model='ngModel' id='searchQuery'\
                                 ng-keyup='keyPressPlanItem($event)'\
                                 placeholder='{{&quot;global.form.search&quot; | translate}}'>\
                                    <span class='input-group-btn'>\
                                        <button class='btn btn-info' ng-click='search()'><span\
                                             class='glyphicon glyphicon-search'></span>\
                                        </button>\
                                    </span>\
                    </div>";

    function searchBox () {
        var directive = {
            restrict: 'E',
            scope: {
                ngModel: '=',
                searchMethod: '&searchMethod'
            },
            require: '?ngModel',
            template: tmplt,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {
                scope.search = function () {
                    scope.searchMethod();
                }
                scope.keyPressPlanItem = function ($event) {
                    if ($event.keyCode == 13) {
                        scope.search();
                    }
                };

            }
        };

        return directive;
    }
})();

